// generators/generateDataGraph.js
export function generateDataGraph() {
  // Randomly pick graph type
  const types = ["bar", "line", "pie", "table"];
  const type = types[Math.floor(Math.random() * types.length)];

  // Generate random data for 3-5 categories/points
  const n = 3 + Math.floor(Math.random() * 3); // 3~5
  const categories = Array.from({length: n}, (_, i) => String.fromCharCode(65+i));
  const values = Array.from({length: n}, () => 2 + Math.floor(Math.random()*8));
  const maxValue = Math.max(...values);

  if (type === "bar") {
    const qTypes = [
      `Which has the highest value?`,
      `Which has the lowest value?`,
      `How much more is ${categories[0]} than ${categories[1]}?`,
      `What is the total?`
    ];
    const qType = qTypes[Math.floor(Math.random()*qTypes.length)];
    let text = "";
    let answer = "";
    switch(qType) {
      case `Which has the highest value?`:
        text = `Bar graph: Categories [${categories.join(", ")}], Values [${values.join(", ")}]. ${qType}`;
        answer = categories[values.indexOf(maxValue)];
        break;
      case `Which has the lowest value?`:
        text = `Bar graph: Categories [${categories.join(", ")}], Values [${values.join(", ")}]. ${qType}`;
        answer = categories[values.indexOf(Math.min(...values))];
        break;
      case `How much more is ${categories[0]} than ${categories[1]}?`:
        text = `Bar graph: Categories [${categories.join(", ")}], Values [${values.join(", ")}]. ${qType}`;
        answer = Math.abs(values[0] - values[1]);
        break;
      default:
        text = `Bar graph: Categories [${categories.join(", ")}], Values [${values.join(", ")}]. ${qType}`;
        answer = values.reduce((a,b)=>a+b,0);
    }
    return {
      type: "bar",
      categories,
      values,
      text,
      answer,
    };
  }

if (type === "line" || type === "table") {
  const text = `${type === "line" ? "Line" : "Table"}: Categories [${categories.join(", ")}], Values [${values.join(", ")}]. What is the total?`;
  const answer = values.reduce((a, b) => a + b, 0);
  return {
    type,
    categories,
    values,
    text,
    answer
  };
}

 if (type === "pie") {
  const total = values.reduce((a,b)=>a+b,0);
  const percents = values.map(v => Math.round(v/total*100));
  const biggest = categories[values.indexOf(maxValue)];
  const qTypes = [
    `Which category has the largest share in the pie chart?`,
    `What percent is category ${categories[0]}?`
  ];
  const qType = qTypes[Math.floor(Math.random()*qTypes.length)];
  if (qType.includes("largest")) {
    return {
      type: "pie",
      categories,
      percents,
      text: `Pie chart: Categories [${categories.join(", ")}], Percentages [${percents.join(", ")}%]. ${qType}`,
      answer: biggest
    };
  } else {
    return {
      type: "pie",
      categories,
      percents,
      text: `Pie chart: Categories [${categories.join(", ")}], Percentages [${percents.join(", ")}%]. ${qType}`,
      answer: percents[0]
    };
  }
}

  // --- FALLBACK（放最後）---
  return {
    type: "table",         // 或 "bar"，根據你希望 fallback 長什麼樣
    categories,
    values,
    text: `Data graph: Categories [${categories.join(", ")}], Values [${values.join(", ")}].`,
    answer: values[0]
  };
}


// generators/generateProbability.js
export function generateProbability() {
  // Choose dice, cards, or spinner
  const types = ["dice", "coin", "cards", "spinner"];
  const type = types[Math.floor(Math.random() * types.length)];

  if (type === "dice") {
    // Die: chance of rolling a 2, or even number, etc
    const dieSides = [4, 6, 8, 10][Math.floor(Math.random()*4)];
    const roll = 1 + Math.floor(Math.random() * dieSides);
    const isEven = roll % 2 === 0;
    const qTypes = [
      [`What is the probability of rolling a ${roll} on a ${dieSides}-sided die?`, `1/${dieSides}`],
      [`What is the probability of rolling an even number on a ${dieSides}-sided die?`, `${dieSides/2}/${dieSides}`]
    ];
    return qTypes[Math.floor(Math.random()*qTypes.length)];
  }

  if (type === "coin") {
    return [`You flip a coin. What is the probability of heads?`, "1/2"];
  }

  if (type === "cards") {
    // Standard deck (no jokers)
    const qTypes = [
      [`A card is drawn from a deck. What is the probability it is a heart?`, "1/4"],
      [`A card is drawn. Probability it is a king?`, "1/13"],
      [`Probability of a red card?`, "1/2"]
    ];
    return qTypes[Math.floor(Math.random()*qTypes.length)];
  }

  if (type === "spinner") {
    const n = 3 + Math.floor(Math.random()*3);
    return [
      `A spinner has ${n} equal sections. What is the probability of landing on one section?`,
      `1/${n}`
    ];
  }

  return [`If you pick a marble from a bag of 5 red and 3 blue, what's the probability of red?`, "5/8"];
}
